import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KanbanViewCardI, KanbanViewListI } from '../../models/kanban-view/kanban-production-viewI';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { KanbanProductionMachineDialogComponent } from '../kanban-production-machine-dialog/kanban-production-machine-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'anterasoftware-production-kanban-view-container',
  templateUrl: './production-kanban-view-container.component.html',
  styleUrls: ['./production-kanban-view-container.component.scss']
})
export class ProductionKanbanViewContainerComponent implements OnInit {

  @Input() public swimLaneList: KanbanViewListI[] = [];
  @Input() public equipments: any[] = [];
  @Output() public onUpdateJob: EventEmitter<any> = new EventEmitter();
  @Output() public editCard: EventEmitter<any> = new EventEmitter();
  public colorWarn = 'warn';
  public modeWarn = 'determinate';
  public valueWarn = 65;
  public bufferValueWarn = 85;
  
  public color = 'success';
  public mode = 'determinate';
  public value = 50;
  public bufferValue = 75;
  @Input() public defaultImg: string = '';
  @Input() public dateFormatString: string = 'DD/MM/YYYY';
  @Input() public timeFormatString: string = 'hh:mm a';

  constructor(private dialog: MatDialog) { 
  }

  ngOnInit(): void {
  }

  drop(event:any,swimLane:KanbanViewListI) {
    if(swimLane && swimLane.header && swimLane.header.title === 'Unscheduled Jobs') {
      let jobId = "";
        if(event && event.value) {
          jobId =  event.value.id
          
        }
        let job = {
          jobId: jobId,
          formValues: {
            machineId: "",
            scheduleDate: "",
          }
        }
      this.onUpdateJob.emit(job)
    } else {
      let dialogRef = this.dialog.open(KanbanProductionMachineDialogComponent, {
      width: '510px',
      height: '240px',
      panelClass: 'custom-dialog-container',
      data: {
        equipments: this.equipments,
        machineId: event.value.machineId
      },
    });

    dialogRef.afterClosed().subscribe((formValues: any) => {
      let jobId = "";
      if(event && event.value) {
        jobId =  event.value.id
        
      }
      if(formValues &&  formValues.machineId !="") {
        let job = {
          job: event.value,
          machineId: formValues.machineId,
          scheduleDate: swimLane.header.scheduleDate
        }
        this.onUpdateJob.emit(job)
      }
    });
  }
  }
}
